export default __webpack_public_path__ + "static/media/wazito-logo.bf64004a.jpg";